/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketssaved1Inputs */

const en_ticketssaved1 = /** @type {(inputs: Ticketssaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket type saved`)
};

const de_ticketssaved1 = /** @type {(inputs: Ticketssaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketart gespeichert`)
};

/**
* | output |
* | --- |
* | "Ticket type saved" |
*
* @param {Ticketssaved1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssaved1 = /** @type {((inputs?: Ticketssaved1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssaved1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssaved1(inputs)
	return de_ticketssaved1(inputs)
});
export { ticketssaved1 as "ticketsSaved" }